export const ops =
  'Ooops, Something went wrong! you might not have the right permissions to preform this action, if you do, try again'

export const snackbarProps = (variant, autoHideDuration, persist) => ({
  variant: variant,
  autoHideDuration: autoHideDuration,
  persist: persist
})

// import { ops, snackbarProps } from '@bund-x/core/Global/Constants'
// Usage: snackbarProps('error', 8005, false)
